import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import AsYouType, { getCountryCallingCode } from "libphonenumber-js"
import { Input } from "../../design";
import {
  FlexContainer,
  H1Text,
  LabelText, SpanText,
  RoundButton,
  SubmitButton,
  Hr,
  SelectBox,
} from "../../design";

import {
  SpError,
  SpText,
} from '../../widgetDesign';
import { COUNTRY_PHONE_CODE } from "../../appconstants";

import { format } from "../../utils/timer";

import PaymentError from "../paymenterror";
import ICICI from '../../assets/imgs/ICICI.png';
import BOB from '../../assets/imgs/BOB.png';
import Kotak from '../../assets/imgs/Kotak.png';
import SBI from '../../assets/imgs/SBI.png';
import Polygon from '../../assets/imgs/Polygon.png';
import { isValidPhoneNumber } from 'libphonenumber-js';
import ReCAPTCHA from 'react-google-recaptcha';
import { AmountDivideByHundred } from "../../helper";

type Props = {
  errorMsg: string,
  errorHeader: string,
  submit: Function,
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  customerDisabled: boolean,
  alpha2: string,
  disableButtonText: string,
  planStartDate: Object,
  currentDateObject: Object,
  cancel: Function,
  showCancelBtn: boolean,
  paymentPage: boolean,
  isTest: boolean,
  cancelButtonText: string,
  banksList: Array,
  bankTypes: Array,
  expireyText: String,
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  count: Number,
  showWhatsAppNotify: boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  prefix: string,
}

const NetBanking = (props: Props) => {
  const { submit, banksList, bankTypes, sitekey, isCaptchaEnabled, isTest, expireyText, count, alpha2, customerFields,
    headerText, buttonText, errorHeader, errorMsg, paymentPage, showWhatsAppNotify,
    disableButtonText, showCancelBtn, cancel, cancelButtonText, netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, prefix } = props;
  const [, forceUpdate] = useState();

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBankList, setSelectedBankList] = useState(null);
  const [fixErrors, setFixErrors] = useState(false);
  const [selectedBankName, setSelectedBankName] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState();
  const [notify, setNotify] = useState(false);
  const [recaptchaToken, setRecaptchToken] = useState(null);

  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      phoneNumValidation: {
        message: 'The phone number is invalid',
        rule: (val, param) => (isValidPhoneNumber(param[0])),
      },
      checkLowerCase: {
        message: 'Email address must not contain uppercase letters.',
        rule: (val) => val === val.toLowerCase(),
      },
    },
  }));

  const options = banksList && banksList.map((item) => {
    let items = Object.assign({ "value": item.paymentType, "label": item.bankName });
    return items;
  }
  )

  useEffect(() => {
    if (paymentPage) {
      setEmail(customerFields && customerFields.contactUsEmail);
      const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      setPhoneNumber(phone && phone.nationalNumber);
      setCountryCode(countryCallingCode);
    }
  }, [customerFields])

  const renderIcon = () => <img src={Polygon} alt="" />

  const customStyles = {
    control: base => ({
      ...base,
      width: '343px',
      height: '36px',
      border: '1px solid #C4C4C4',
      borderRadius: '6px',
    }),
    option: (base, state) => ({
      ...base,
      width: '342px',
      padding: '15px',
      borderBottom: '1px solid #EBEBEB',
    }),
    container: provided => ({
      ...provided,
      width: '342px',
    }),
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#FFFFFF"
      },
      "::-webkit-scrollbar-thumb": {
        background: "#DBDBDB",
        border: "4px solid #DBDBDB"
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#DBDBDB"
      }
    }),
  };

  const baseStyles = {
    control: base => ({
      ...base,
      width: '90px',
      height: '32px',
      marginTop: '6px',
      border: '1px solid #C4C4C4',
      borderRadius: '6px',
    }),
  };

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const netBankingDetails = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    const validBank = bankTypes.includes(selectedBank);
    setShowErrorMessage(false);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    if (formValid && !validBank) {
      setFixErrors(true);
      forceUpdate(1);
      return;
    }
    const payload = banksList.filter(data => (data.paymentType === selectedBank));
    const gid = payload[0].gid;
    const phone = phoneNumber ? countryCode && `${countryCode}${phoneNumber}` : null;
    const customer = { name, email, phoneNumber: phone };
    if (isCaptchaEnabled) {
      if (recaptchaToken) {
        submit({
          customer,
          gid,
          notify,
          recaptchaToken,
        });
      }
    } else {
      submit({
        customer,
        gid,
        notify,
      });
    }

  };

  const updateBankName = (e) => {
    setFixErrors(false);
    setShowErrorMessage(false);
    if (e === 'NET_BANKING_ICICI_BANK') {
      setSelectedBank(e);
      setSelectedBankName('ICICI Bank');
      setSelectedBankList({ value: 'NET_BANKING_ICICI_BANK', label: 'ICICI Bank' });
    } else if (e === 'NET_BANKING_KOTAK_MAHINDRA_BANK') {
      setSelectedBank(e);
      setSelectedBankName('Kotak Mahindra Bank');
      setSelectedBankList({ value: 'NET_BANKING_KOTAK_MAHINDRA_BANK', label: 'Kotak Mahindra Bank' });
    } else if (e === 'NET_BANKING_BANK_OF_BARODA_RETAIL_BANKING') {
      setSelectedBank(e);
      setSelectedBankName('Bank of Baroda - Retail Banking');
      setSelectedBankList({ value: 'NET_BANKING_BANK_OF_BARODA_RETAIL_BANKING', label: 'Bank of Baroda - Retail Banking' });
    } else if (e === 'NET_BANKING_STATE_BANK_OF_INDIA') {
      setSelectedBank(e);
      setSelectedBankName('State Bank Of India');
      setSelectedBankList({ value: 'NET_BANKING_STATE_BANK_OF_INDIA', label: 'State Bank Of India' });
    } else {
      setSelectedBank(e.value);
      setSelectedBankList(e);
      setSelectedBankName(e.label);
    }
  };

  const onCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  return (
    <>
      {
        expireyText && (
          <p className="px-1 px-md-4 mb-4">
            {expireyText} <span style={{ fontWeight: "600" }}>{format(count)}</span>
          </p>
        )
      }
      <H1Text
        className="px-1 px-md-4 mb-0"
      >
        {headerText || "PAY WITH NET BANKING"}
      </H1Text>
      <div
        style={{
          width: '100%',
        }}>
        <FlexContainer
          flexDirection="column"
        >
          <div className="px-1 px-md-4 mt-2 w-100">
            {
              (paymentPage) && (
                <>
                  <LabelText className="mb-1">
                    Name
                  </LabelText>
                  <Input
                    placeholder="Name"
                    value={name}
                    style={{
                      width: '343px',
                      height: '36px',
                      border: '1px solid #C4C4C4',
                      borderRadius: '6px',
                    }}
                    onChange={(e) => setName(e.currentTarget.value)}
                    onBlur={() => setName(name.trim())}
                  />
                  <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                    {simpleValidator.current.message('Name', name, 'required|alpha_space')}
                  </SpError>
                  <LabelText className="mt-2">
                    Email
                  </LabelText>
                  <Input
                    placeholder="Email"
                    style={{
                      width: '343px',
                      height: '36px',
                      border: '1px solid #C4C4C4',
                      borderRadius: '6px',
                    }}
                    value={email}
                    onChange={(e) => setEmail(e.currentTarget.value)}
                  />
                  <SpError fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">
                    {simpleValidator.current.message('email', email, 'required|email|checkLowerCase')}
                  </SpError>
                  <LabelText className="mt-2">
                    Phone
                  </LabelText>

                  <div className="d-flex">
                    <div className="form-group" style={{ width: '90px', }}>
                      <SelectBox
                        className="form-control"
                        value={countryCode}
                        onChange={onCountryCodeChange}
                        style={{
                          width: '90px',
                          height: '36px',
                          border: '1px solid #C4C4C4',
                          borderRadius: '6px',
                        }}
                      >
                        <option value={countryCode} hidden>{countryCode}</option>
                        {
                          COUNTRY_PHONE_CODE.map((item) => (
                            <option key={item} value={item}>{item}</option>
                          ))
                        }
                      </SelectBox>
                      <SpError>
                        {simpleValidator.current.message('country Code', countryCode, 'required')}
                      </SpError>
                    </div>
                    <div>
                      <Input
                        style={{
                          width: '250px',
                          height: '36px',
                          border: '1px solid #C4C4C4',
                          borderRadius: '6px',
                        }}
                        onChange={(e) => setPhoneNumber(e.currentTarget.value)}
                        value={phoneNumber}
                      />
                      <SpError>
                        {simpleValidator.current.message('phone number', phoneNumber, `phoneNumValidation:${countryCode}${phoneNumber}`)}
                      </SpError>
                    </div>
                  </div>
                  <Hr />
                </>
              )
            }
            {
              isTest && (
                <>
                  <LabelText>
                    More Banks
                  </LabelText>

                  <div className="mt-2 ml-1 w-50">
                    <Select
                      placeholder="Search Bank"
                      styles={customStyles}
                      menuPlacement="top"
                      arrowrenderer={renderIcon}
                      options={options}
                      isSearchable="true"
                      value={selectedBankList}
                      onChange={updateBankName}
                      components={{
                        IndicatorSeparator: () => null,
                        DropdownIndicator: () => <img src={Polygon} style={{ padding: '10px' }} alt="" />
                      }}
                      id="search-select"
                    />
                  </div>
                  <div className="ml-1 mt-2">
                    <SpError>
                      {
                        fixErrors ? (
                          <>
                            {`Netbanking from bank ${selectedBankName} is not enabled by this merchant`}
                          </>
                        ) : (
                          <>
                            {simpleValidator.current.message('bank', selectedBank, 'required')}
                          </>
                        )
                      }
                    </SpError>
                  </div>
                  {/* {
                    showWhatsAppNotify && (
                      <div className="mt-3 ml-1">
                        <label>
                          <Input
                            type="checkbox"
                            checked={notify}
                            onChange={({ target: { checked } }) => {
                              setNotify(checked);
                            }} width="auto" />
                          <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
                      </div>
                    )
                  } */}
                </>
              )
            }
            {
              !isTest && (
                <>
                  <LabelText>
                    Popular Banks
                  </LabelText>
                  <div className="mb-0">
                    <RoundButton
                      className="ml-2 mr-4"
                      onClick={() =>
                        updateBankName('NET_BANKING_ICICI_BANK')
                      }
                    >
                      <img
                        src={ICICI}
                        alt="ICICI"
                      />
                    </RoundButton>
                    <RoundButton
                      className="mr-4"
                      onClick={() => updateBankName('NET_BANKING_KOTAK_MAHINDRA_BANK')}
                    >
                      <img
                        src={Kotak}
                        alt="Kotak"
                      />
                    </RoundButton>
                    <RoundButton
                      className="mr-4"
                      onClick={() => updateBankName('NET_BANKING_STATE_BANK_OF_INDIA')}
                    >
                      <img
                        src={SBI}
                        alt="SBI"
                      />
                    </RoundButton>
                    <RoundButton
                      className="mr-4"
                      onClick={() => updateBankName('NET_BANKING_BANK_OF_BARODA_RETAIL_BANKING')}
                    >
                      <img
                        src={BOB}
                        alt="BOB"
                      />
                    </RoundButton>
                  </div>
                  <div style={{ marginBottom: '15px', marginTop: '-10px' }}>
                    <SpText
                      className="ml-3 mr-4">
                      ICICI
                    </SpText>
                    <SpText
                      className="ml-3 mr-4">
                      Kotak
                    </SpText>
                    <SpText
                      className="ml-2 mr-4">
                      SBI
                    </SpText>
                    <SpText
                      className="ml-3 mr-4">
                      BOB
                    </SpText>
                  </div>
                  <Hr className="w-50" style={{ marginTop: '20px' }} />
                  <LabelText>
                    More Banks
                  </LabelText>

                  <div className="select-up mt-2 ml-1 w-50">
                    <Select
                      placeholder="Search Bank"
                      styles={customStyles}
                      menuPlacement="top"
                      arrowrenderer={renderIcon}
                      options={options}
                      isSearchable="true"
                      onChange={updateBankName}
                      components={{
                        IndicatorSeparator: () => null,
                        DropdownIndicator: () => <img src={Polygon} style={{ padding: '10px' }} alt="" />
                      }}
                      id="search-select"
                      value={selectedBankList}
                    />
                  </div>
                  <div className="ml-1 mt-2">
                    <SpError>
                      {
                        fixErrors ? (
                          <>
                            {`Netbanking from bank ${selectedBankName} is not enabled by this merchant`}
                          </>
                        ) : (
                          <>
                            {simpleValidator.current.message('bank', selectedBank, 'required')}
                          </>
                        )
                      }
                    </SpError>
                  </div>
                  {/* {
                    showWhatsAppNotify && (
                      <div className="mt-3 ml-1">
                        <label>
                          <Input
                            type="checkbox"
                            checked={notify}
                            onChange={({ target: { checked } }) => {
                              setNotify(checked);
                            }} width="auto" />
                          <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
                      </div>
                    )
                  } */}
                </>
              )
            }
            {
              sitekey && (isCaptchaEnabled === true) && (
                <>
                  <div className="mt-3">
                    <ReCAPTCHA
                      sitekey={sitekey}
                      value={recaptchaToken}
                      onChange={(value) => {
                        setRecaptchToken(value);
                      }}
                    />
                  </div>
                  <div className="ml-1 mt-2">
                    <SpError>
                      {simpleValidator.current.message('captcha', recaptchaToken, 'required',
                        { messages: { required: 'Captch is required' } })}
                    </SpError>
                  </div>
                </>
              )
            }
          </div>
          {
              (serviceFeeEnabled === true) && (
                <>
                <Hr />
                <div className="px-1 px-md-4">
                  <div class="mt-4">
                    <table class="table table-bordered mt-4">
                      <tbody>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Amount:</th>
                          <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                        </tr>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Service Fee:</th>
                          <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                        </tr>
                        <tr style={{ background: '#F7F7F7' }}>
                          <th scope="row">Total Payable:</th>
                          <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </>
              )
            }
            <div className="px-1 px-md-4">
              <FlexContainer
                width="100%"
                alignItems="center"
                className='justify-content-sm-start justify-content-between'
              >
                {
                  showCancelButton && cancel &&
                  <SpanText
                    onClick={onCancel}
                    cursor="pointer"
                    color="#40A9FF"
                    className="cursor-pointer ml-sm-0 ml-2 mr-sm-5 pt-3"
                  >{cancelButtonText || "Cancel"}</SpanText>
                }
                {disableButtonText ?
                  (
                    <SubmitButton
                      type="submit"
                      onClick={netBankingDetails}
                      disabled
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                  : (
                    <SubmitButton
                      type="submit"
                      onClick={netBankingDetails}
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                }
              </FlexContainer>
              {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} />}
              {(disableButtonText) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
            </div>
        </FlexContainer>
      </div>
    </>
  )
};

export default NetBanking;